import React, { useState } from 'react';
import axios from 'axios';
import {
	Box,
	Button,
	FormControl,
	FormLabel,
	Heading,
	HStack,
	Input,
	Select,
	Spacer,
} from '@chakra-ui/react';
import { options } from './data';

export const NewTicket = ({ admin, customer, workers, setWake }) => {
	const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
	const [newAssignee, setNewAssignee] = useState(0);
	const [title, setTitle] = useState('');
	const [content, setContent] = useState('');
	const [dueDate, setDueDate] = useState(new Date());

	const chooseAssignee = e => {
		setNewAssignee(e.target.value);
		setIsSubmitDisabled(false);
	};

	const submitNewTicket = () =>
		axios({
			method: 'post',
			url: `/tickets`,
			data: {
				reporter: admin,
				assignee: newAssignee,
				title,
				content,
				customer,
				dueDate,
			},
			...options(),
		})
			.then(() => {
				setIsSubmitDisabled(true);
				setNewAssignee(0);
				setTitle('');
				setContent('');
				setWake(new Date().getTime());
			})
			.catch(console.log);

	return (
		<Box borderRadius="md" border="1px" borderColor="gray.200" p={4} mr={4}>
			<Heading pb={6} fontSize={'xl'}>
				New ticket
			</Heading>
			<Box>
				<FormControl mb={4}>
					<FormLabel>Title</FormLabel>
					<Input
						type="text"
						placeholder="Enter the ticket title here"
						value={title}
						onChange={e => setTitle(e.target.value)}
					/>
				</FormControl>
				<Box mb={4}></Box>
				<FormControl mb={4}>
					<FormLabel>Content</FormLabel>
					<Input
						type="text"
						placeholder="Enter the ticket content here"
						value={content}
						onChange={e => setContent(e.target.value)}
					/>
				</FormControl>
			</Box>
			<HStack pb={6}>
				<Box>
					<Select placeholder="Choose an assignee" onChange={chooseAssignee} value={newAssignee}>
						{workers.map(({ id, name }) => (
							<option value={id}>
								{name}
							</option>
						))}
					</Select>
				</Box>
				<Spacer />
				<Box>
					{' '}
					<Input
						type="date"
						value={dueDate}
						onChange={e => setDueDate(e.target.value)}
					/>
				</Box>
				<Spacer />
				<Button
					colorScheme="blue"
					isDisabled={isSubmitDisabled}
					onClick={submitNewTicket}
				>
					Create ticket
				</Button>
			</HStack>
		</Box>
	);
};
